import BuddhaEnclaveGate from "../assets/propertiesimage/buddhaInclaveGate.png";
import BuddhaEnclaveOne from "../assets/propertiesimage/buddhaInclaveOne.jpeg";
import BuddhaEnclaveTwo from "../assets/propertiesimage/buddhaInclaveTwo.jpeg";
import BuddhaEnclaveThree from "../assets/propertiesimage/buddhaInclaveThree.jpeg";
import BuddhaEnclaveVideo from "../assets/propertiesimage/buddhaInclaveVideo.mp4";
import RiseValleyGate from "../assets/propertiesimage/RiseValley Gate.png";
import RiseValleyOne from "../assets/propertiesimage/riseValleyOne.jpeg";
import RiseValleyTwo from "../assets/propertiesimage/riseValleyTwo.jpeg";
import RiseValleyThree from "../assets/propertiesimage/riseValleyThree.jpeg";
import RiseValleyVideo from "../assets/propertiesimage/riseValley video.mp4";
import SportsVilleFarmsGate from "../assets/propertiesimage/SportsVille FarmsGate.png";
import SportsVilleFarmsTwo from "../assets/propertiesimage/SportsVille FarmsTwo.jpg";
import SportsVilleFarmsThree from "../assets/propertiesimage/SportsVille FarmsThree.jpg";
import SportsVilleFarmsVideo from "../assets/propertiesimage/SportsVille Farms Video.mp4";
import GangaValleyGate from "../assets/propertiesimage/GangaValleyGate.png";
import GangaValleyOne from "../assets/propertiesimage/gangavalleyOne.jpeg";
import GangaValleyTwo from "../assets/propertiesimage/gangavalleyTwo.jpeg";
import GangaValleyThree from "../assets/propertiesimage/gangavalleyThree.jpeg";
import GangaValleyFour from "../assets/propertiesimage/gangavalleyFour.jpeg";
import GangaValleyFive from "../assets/propertiesimage/gangavalleyFive.jpeg";
import GangaValleySix from "../assets/propertiesimage/gangavalleySix.jpeg";

export const allProperties = [
    {
        id: 1,
        title: "Buddha Enclave",
        location: "Greater Noida",
        subLocation: "Near Galgotias University",
        price: 30000,
        priceDisplay: "₹34,999 / sq yd",
        tag: "Residential Plot",
        type: "Plot",
        image: BuddhaEnclaveGate,
        media: [
            { type: "image", src: BuddhaEnclaveGate, label: "Gate View" },
            { type: "image", src: BuddhaEnclaveOne, label: "Layout 1" },
            { type: "image", src: BuddhaEnclaveTwo, label: "Layout 2" },
            { type: "image", src: BuddhaEnclaveThree, label: "Layout 3" },
            { type: "video", src: BuddhaEnclaveVideo, label: "Site Video" },
        ],
        featured: true,
    },
    {
        id: 2,
        title: "Rise Valley",
        location: "Jhajjar, Sikandrabad",
        subLocation: "Near Jewar International Airport",
        price: 25000,
        priceDisplay: "₹25,000 / sq yd",
        tag: "Investment Zone",
        type: "Plot",
        image: RiseValleyGate,
        media: [
            { type: "image", src: RiseValleyGate, label: "Gate View" },
            { type: "image", src: RiseValleyOne, label: "Layout 1" },
            { type: "image", src: RiseValleyTwo, label: "Layout 2" },
            { type: "image", src: RiseValleyThree, label: "Layout 3" },
            { type: "video", src: RiseValleyVideo, label: "Site Video" },
        ],
        featured: true,
    },
    {
        id: 3,
        title: "Sportsville Farm",
        location: "Noida Sector 151",
        subLocation: "Farm Plots",
        price: 9500,
        priceDisplay: "₹9,500 / sq yd",
        tag: "Farm Land",
        type: "Farmhouse",
        image: SportsVilleFarmsGate,
        media: [
            { type: "image", src: SportsVilleFarmsGate, label: "Gate View" },
            { type: "image", src: SportsVilleFarmsTwo, label: "Farm View 1" },
            { type: "image", src: SportsVilleFarmsThree, label: "Farm View 2" },
            { type: "video", src: SportsVilleFarmsVideo, label: "Site Video" },
        ],
        featured: true,
        heroImageFit: {
            objectFit: "contain",
            objectPosition: "center center",
            scale: 1,
        },
    },
    {
        id: 4,
        title: "Ganga Valley",
        location: "Mathura, Uttar Pradesh",
        subLocation: "Near Yamuna Expressway",
        price: 33000,
        priceDisplay: "₹33,000 / sq yd",
        tag: "Plots",
        type: "Plot",
        image: GangaValleyGate,
        media: [
            { type: "image", src: GangaValleyGate, label: "Gate View" },
            { type: "image", src: GangaValleyOne, label: "Site View 1" },
            { type: "image", src: GangaValleyTwo, label: "Site View 2" },
            { type: "image", src: GangaValleyThree, label: "Site View 3" },
            { type: "image", src: GangaValleyFour, label: "Site View 4" },
            { type: "image", src: GangaValleyFive, label: "Site View 5" },
            { type: "image", src: GangaValleySix, label: "Site View 6" },
        ],
        featured: true,
    },
];
